import api from './api';

export const documentService = {
   getAll: (params) => api.get('/documents', { params }).then((r) => r.data),
   getById: (id) => api.get(`/documents/${id}`).then((r) => r.data),
   create: (data) => api.post('/documents', data).then((r) => r.data),
   update: (id, data) => api.put(`/documents/${id}`, data).then((r) => r.data),
   delete: (id) => api.delete(`/documents/${id}`).then((r) => r.data),
   duplicate: (id) => api.post(`/documents/${id}/duplicate`).then((r) => r.data),
   regenerateToken: (id) => api.post(`/documents/${id}/regenerate-token`).then((r) => r.data),
   uploadAttachment: (file) => {
      const form = new FormData();
      form.append('file', file);
      return api
         .post('/documents/upload-attachment', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
         })
         .then((r) => r.data);
   },
};
